
<img
  :src="`${mixinEnvironnement_damPath}/jel/${getUrlGifCourant(content.image)}`"
  :alt="content.image['@name']"
/>
